import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Splash from 'App/Splash'
import userManager from './userManager'
import { withLastLocation } from 'react-router-last-location'

const routeLastLocation = (lastLocation) => {
  const { pathname = '/', search = '' } = lastLocation || {}
  const table = ({
    [pathname]: pathname
  })

  return table[pathname].concat(search)
}

class Login extends Component {
  componentDidMount () {
    const { lastLocation } = this.props
    const lastLocationUri = routeLastLocation(lastLocation)
    const localStorage = typeof window !== 'undefined' && window ? window.localStorage : null
    if (localStorage) {
      let localStoraLocation = localStorage.getItem('lastLocationUri')
      if (!localStoraLocation) {
        localStorage.setItem('lastLocationUri', lastLocationUri)
      }
    }
    userManager.signinRedirect({ state: lastLocationUri })
  }

  render () {
    return <Splash text='Redirecionando para o login' />
  }
}

Login.propTypes = {
  lastLocation: PropTypes.object
}

export default withLastLocation(Login)



// WEBPACK FOOTER //
// ./src/Auth/Login.js